var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_12749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 0H4.92188C2.20795 0 0 2.20795 0 4.92188V19.0781C0 21.792 2.20795 24 4.92188 24H19.0781C21.792 24 24 21.792 24 19.0781V4.92188C24 2.20795 21.792 0 19.0781 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.33398L10.9767 13.9822C11.5787 14.4501 12.4213 14.4501 13.0233 13.9822L19 9.33398V15.9996C19 16.2649 18.8947 16.5192 18.707 16.7065C18.5197 16.8942 18.2653 16.9995 18 16.9995C15.211 16.9995 8.789 16.9995 6 16.9995C5.73466 16.9995 5.48033 16.8942 5.293 16.7065C5.10533 16.5192 5 16.2649 5 15.9996L5 9.33398Z",
    fill: "#416EAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8.00689C18.998 8.30719 18.8603 8.5975 18.614 8.78914L12.614 13.4553C12.2527 13.7363 11.7473 13.7363 11.386 13.4553L5.386 8.78914C5.13967 8.5975 5.002 8.30719 5 8.00689V7.99989C5 7.73459 5.10533 7.48028 5.293 7.29297C5.48033 7.10532 5.73466 7 6 7H18C18.2653 7 18.5197 7.10532 18.707 7.29297C18.8947 7.48028 19 7.73459 19 7.99989V8.00689Z",
    fill: "#416EAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_12749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail_ic.479d38de68bf33629c1a6757743127e9.svg";
export { ForwardRef as ReactComponent };